import { render, staticRenderFns } from "./accountStrategy.vue?vue&type=template&id=b26a0868&"
import script from "./accountStrategy.vue?vue&type=script&lang=js&"
export * from "./accountStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports